import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import { SvgIconProps } from '@mui/material';

export const DoubleArrowDown = (props: SvgIconProps) => (
    <KeyboardDoubleArrowDownIcon sx={{ width: '14px', height: '14px' }} {...props} />
);
